export const MAP = 'MAP';
export const DELETE = 'DELETE';
export const OFF = 'OFF';
